<template>
  <div>
    <div class="user-detail-content">
      <div class="heading">
        <div class="left-heading text-start"><h2>Create new project</h2></div>
      </div>
    </div>
    <div class="modal-edit-user-content">
      <div
        id="edit-user-modal"
        tabindex="-1"
        aria-labelledby="edit-user-modal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered dialog-edit-user">
          <div class="modal-content">
            <ValidationObserver v-slot="{ handleSubmit }">
              <div class="modal-body text-start">
                <div>
                  <div class="row mb-4">
                    <div class="col-6 mb-2">
                      Project name <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 input-group">
                      <ValidationProvider
                        name="Project name"
                        :rules="{ required: true }"
                        v-slot="{ errors }"
                        class="w-100"
                      >
                        <div class="note">Phải lấy đúng tên trên Channel</div>
                        <input
                          class="form-control"
                          type="text"
                          v-model="projectName"
                          placeholder="Project name"
                          @input="debouncedQuery"
                        />
                        <span class="error text-left f-w3">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                      <span
                        class="error text-left f-w3"
                        v-show="projectNotFound && !projectNotExisted"
                      >
                        {{
                          `Not found Channel Teams named ${projectName}`
                        }}</span
                      >
                      <span
                        class="error text-left f-w3"
                        v-show="projectNotExisted"
                      >
                        {{ `Project with ${projectName} existed` }}</span
                      >
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-12 mb-2">
                      Division <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 input-group">
                      <input
                        class="form-control"
                        type="text"
                        v-model="divisionName"
                        placeholder="Division"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-6 mb-2">
                      Teams Group <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 input-group">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Teams Group"
                        v-model="groupname"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-6 mb-2">
                      Teams Channel <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 input-group">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Teams Channel"
                        v-model="channelName"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-6 mb-2">
                      Chatwork room url <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 input-group">
                      <ValidationProvider
                        name="Chatwork room url"
                        :rules="{ required: true }"
                        v-slot="{ errors }"
                        class="w-100"
                      >
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Chatwork room url"
                          v-model="chatworkRoomURL"
                          @input="debouncedQueryForChatWork"
                        />
                        <span class="error text-left f-w3">{{
                          errors[0]
                        }}</span>
                        <span
                          class="error text-left f-w3"
                          v-show="wrongChatworkID"
                        >
                          {{
                            `Not found chatwork room: ${chatworkRoomURL}`
                          }}</span
                        >
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-6 mb-2">Webhook URL</div>
                    <div class="col-12 input-group">
                      <input
                        class="form-control"
                        type="text"
                        :placeholder="hookLink"
                        v-model="hookLink"
                        disabled
                      />
                    </div>
                    <div class="mt-3">
                      <a
                        href="https://amelavn-my.sharepoint.com/:w:/r/personal/khanh_lethiminh_amela_vn/Documents/Microsoft%20Teams%20Chat%20Files/HDSD_ChatworkTool.docx?d=w41696b3dc8d1416092af2b0710344ad5&csf=1&web=1&e=NUgnxA"
                        style="float: right"
                        target="_blank"
                        >How to chatwork webhook</a
                      >
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-6 mb-2">
                      Customer Account <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 input-group">
                      <v-select
                        v-model="selectedCustomer"
                        :options="listUserInChatWork"
                        multiple
                        :reduce="(name) => name.id"
                        label="name"
                        placeholder="Please select"
                      >
                      </v-select>

                      <span
                        class="error text-left f-w3 col-12"
                        v-show="showErrorNotSelectCustomer"
                      >
                        {{ `Let's select a Customer` }}</span
                      >
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-6 mb-2">
                      PM Account <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 input-group">
                      <v-select
                        v-model="selectedPm"
                        :options="listUserInTeams"
                        :reduce="(name) => name.id"
                        label="name"
                        placeholder="Please select one"
                      >
                      </v-select>
                      <span
                        class="error text-left f-w3 col-12"
                        v-show="showErrorNotSelectPM"
                      >
                        {{ `Let's select a PM` }}</span
                      >
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-6 mb-2">BrSE/Comtor Account</div>
                    <div class="col-12 input-group">
                      <v-select
                        v-model="selectedBrse"
                        :options="listUserInTeams"
                        :reduce="(name) => name.id"
                        label="name"
                        placeholder="Please select one"
                      >
                      </v-select>
                      <span
                        class="error text-left f-w3 col-12"
                        v-show="showErrorNotSelectBrseComtor"
                      >
                        {{ `Let's select a BrSE/Comtor` }}</span
                      >
                    </div>
                  </div>
                  <div class="row mb-5 align-items-center">
                    <div class="col-3">Remind</div>
                    <div class="w-25 input-group">
                      <select v-model="selectedRemind">
                        <option
                          v-for="option in getTimeSelect()"
                          v-bind:key="option.id"
                          :value="option.id"
                        >
                          {{ option.data }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="button-group justify-content-center d-flex">
                    <button
                      type="button"
                      class="btn btn-warning text-white"
                      v-on:click.prevent.stop="handleSubmit(createProject)"
                    >
                      Create
                    </button>
                  </div>
                </div>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import { MESSAGES, MODAL } from "@/utils/const";

export default {
  name: "CreateProject",
  components: {},
  data() {
    return {
      selectedCustomer: [],
      selectedPm: "",
      selectedBrse: "",
      selectedRemind: "1H",
      channelName: "",
      teamsChannelId: "",
      groupname: "",
      teamsGroupId: "",
      projectName: "",
      divisionName: "",
      projectNotFound: false,
      chatworkRoomURL: "",
      wrongChatworkID: false,
      showErrorNotSelectPM: false,
      showErrorNotSelectCustomer: false,
      showErrorNotSelectBrseComtor: false,
      projectNotExisted: false,
      listUserInChatWork: [],
      listUserInTeams: [],
      hookLink: `${process.env.VUE_APP_MY_ENV_BASE_API_URL}/bots/webhook`,
    };
  },
  mounted() {},
  created() {},
  watch: {
    selectedPm() {
      this.showErrorNotSelectPM = false;
    },
    selectedCustomer() {
      this.showErrorNotSelectCustomer = false;
    },
    selectedBrse() {
      this.showErrorNotSelectBrseComtor = false;
    },
  },
  methods: {
    getTimeSelect() {
      return [
        { id: "15P", data: "00:15" },
        { id: "1H", data: "01:00" },
        { id: "2H", data: "02:00" },
        { id: "4H", data: "04:00" },
        { id: "8H", data: "08:00" },
        { id: "12H", data: "12:00" },
        { id: "24H", data: "24:00" },
      ];
    },
    getGroupTeams() {
      this.projectNotFound = false;
      this.projectNotExisted = false;
      this.showErrorNotSelectBrseComtor = false;
      this.showErrorNotSelectPM = false;
      this.selectedBrse = "";
      this.selectedPm = "";
      if (_.isEmpty(this.projectName)) {
        return;
      }
      var match = /(.*)-/.exec(this.projectName);
      if (!_.isEmpty(match)) {
        this.divisionName = match[1].trim();
      }
      this.$root.$refs.loading.start();
      let params = {
        name: this.projectName,
      };
      this.$store
        .dispatch("projects/getProjectTeams", params)
        .then((response) => {
          this.$root.$refs.loading.finish();
          this.channelName = response.channelName;
          this.groupname = response.groupname;
          this.teamsChannelId = response.channelId;
          this.teamsGroupId = response.groupId;
        })
        .catch(() => {
          this.projectNotFound = true;
          this.$root.$refs.loading.finish();
        });
      this.$store
        .dispatch("user/getUserInTeams", params)
        .then((response) => {
          this.$root.$refs.loading.finish();
          this.listUserInTeams = response;
        })
        .catch(() => {
          this.$root.$refs.loading.finish();
        });
    },
    getListUserInChatWork() {
      var match = /#!rid(.*)/.exec(this.chatworkRoomURL);
      this.wrongChatworkID = false;
      this.showErrorNotSelectCustomer = false;
      if (_.isEmpty(match)) {
        if (this.chatworkRoomURL !== "") {
          this.wrongChatworkID = true;
        }
        return;
      }
      this.$root.$refs.loading.start();
      let params = {
        id: match[1],
      };
      this.$store
        .dispatch("user/getUsersInChatWork", params)
        .then((response) => {
          this.listUserInChatWork = response;
          this.$root.$refs.loading.finish();
        })
        .catch(() => {
          this.listUserInChatWork = [];
          this.wrongChatworkID = true;
          this.$root.$refs.loading.finish();
        });
    },
    createProject() {
      if (this.selectedCustomer.length === 0) {
        this.showErrorNotSelectCustomer = true;
      }
      if (this.selectedPm === "") {
        this.showErrorNotSelectPM = true;
      }
      this.$root.$refs.loading.start();
      let listUser = [];
      if (this.selectedCustomer.length > 0) {
        listUser = this.selectedCustomer.map((item, ind) => {
          return {
            userId: this.selectedCustomer[ind],
            role: "Customer",
          };
        });
      } else {
        listUser.push({
          userId: "",
          role: "Customer",
        });
      }

      let body = {
        projectName: this.projectName,
        chatworkRoomUrl: this.chatworkRoomURL,
        teamsGroupId: this.teamsGroupId,
        teamsChannelId: this.teamsChannelId,
        timeMention: this.selectedRemind,
        divisionName: this.divisionName,
        users: [
          ...listUser,
          {
            userId: this.selectedPm,
            role: "Pm",
          },
        ],
      };
      if (this.selectedBrse !== "") {
        body.users.push({
          userId: this.selectedBrse,
          role: "ComtorBrse",
        });
      }
      this.$store
        .dispatch("projects/createNewProject", body)
        .then((response) => {
          console.log(response);
          this.$toast(
            MESSAGES.CREATE_PROJECT_SUCCESS,
            MODAL.MODAL_SUCCESS,
            MODAL.MODAL_TYPE_SUCCESS
          );
          this.$router.go(-1);
          this.$root.$refs.loading.finish();
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$toast(
              MESSAGES.PROJECT_EXISTED,
              MODAL.MODAL_SUCCESS,
              MODAL.MODAL_TYPE_DANGER
            );
          }
          this.$root.$refs.loading.finish();
        });
    },
    debouncedQuery: _.debounce(function () {
      this.getGroupTeams();
    }, 1500),
    debouncedQueryForChatWork: _.debounce(function () {
      this.getListUserInChatWork();
    }, 1500),
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/projects/create.scss";
</style>
